import type { SingleAssetValueOverview } from '@einwert/valuation-api-client'
import { useGetFilteredMultiAssetValueOverview, useGetMultiAssetValueOverview } from 'ClientPortal/src/api/Queries/value-overview'

import { assembleAssetTitle } from 'ComponentLibrary'
import { useSearchParams } from 'react-router-dom'

export const sortAssetsAlphabetically = (assets: SingleAssetValueOverview[]) =>
    [...assets].sort((assetA, assetB) => {
        const titleA = assetA.customer_asset_reference || assembleAssetTitle(assetA.address)
        const titleB = assetB.customer_asset_reference || assembleAssetTitle(assetB.address)
        return titleA.localeCompare(titleB, 'de', { sensitivity: 'base' })
    })

export function useAnalysisData() {
    const [searchParams] = useSearchParams()
    const selectedAssets = searchParams.get('assets')?.split(',')
    const { multiAssetValueOverviewData, isMultiAssetValueOverviewDataPending } = useGetMultiAssetValueOverview({
        throwOnError: true,
        retry: false,
    })
    const {
        multiAssetValueOverviewData: filteredMultiAssetValueOverviewData,
        isMultiAssetValueOverviewDataPending: isFilteredMultiAssetValueOverviewDataPending,
    } = useGetFilteredMultiAssetValueOverview({ assetIds: selectedAssets, throwOnError: true, retry: false })
    const assets = sortAssetsAlphabetically(multiAssetValueOverviewData?.assets || [])
    const historyOverview = selectedAssets?.length ? filteredMultiAssetValueOverviewData : multiAssetValueOverviewData

    return {
        assets,
        filteredSummary: filteredMultiAssetValueOverviewData?.summary,
        isFilteredSummaryPending: isFilteredMultiAssetValueOverviewDataPending,
        history: historyOverview?.history,
        normalizedHistory: historyOverview?.normalized_history,
        summary: multiAssetValueOverviewData?.summary,
        isMultiAssetValueOverviewDataPending,
    }
}
